/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const OrcidIconConfig = {
  name: 'OrcidIcon',
  height: 512,
  width: 512,
  svgPath: 'M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(OrcidIconConfig);
//# sourceMappingURL=orcid-icon.js.map